
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M62.262 18.078a8.016 8.016 0 00-4.21-4.45 7.993 7.993 0 00-6.122-.167l-25.852 9.847a8.002 8.002 0 00-4.629 10.32l15.922 41.743 2.488 6.539a8.003 8.003 0 0010.332 4.629l25.81-9.848a7.999 7.999 0 004.628-10.32L62.262 18.078zm-21.871 54L25.2 32.211a4.002 4.002 0 012.313-5.16l25.848-9.852a4.002 4.002 0 015.16 2.313l15.199 39.87L40.39 72.079zM76.84 70.84a4.006 4.006 0 01-2.23 2.101l-25.849 9.86a3.999 3.999 0 01-5.16-2.313l-1.78-4.672L75.147 63.11l1.781 4.672a4.004 4.004 0 01-.09 3.07l.001-.011zM62.57 73a2.553 2.553 0 01-.633 2.773 2.56 2.56 0 01-4.316-1.934 2.552 2.552 0 011.648-2.32A2.56 2.56 0 0162.57 73zm-29.172 2.3a1.996 1.996 0 01-2.527 1.25c-.45-.148-11.07-3.82-15.5-13.84C13 57.36 12.879 51.29 15 44.62l-3 1.173v-.004a1.997 1.997 0 01-2.59-1.14 2 2 0 011.14-2.59l7.16-2.79c.231-.086.473-.129.72-.129.117-.011.234-.011.35 0 .259.059.505.168.72.32l.16.13.14.12c.06.063.11.13.16.2l.079.11c.074.109.133.226.18.35l2.75 7a2 2 0 11-3.731 1.45l-.809-2.078C17 52.129 17.18 56.898 19 61.07c3.7 8.398 13 11.672 13.13 11.699a2.003 2.003 0 011.27 2.531h-.001zm56.07-22.222l-7.168 2.8h-.23c-.164.047-.332.07-.5.07a2.115 2.115 0 01-.52-.077h-.289a1.582 1.582 0 01-.262-.153h-.07a1.95 1.95 0 01-.39-.347l-.04-.153a1.964 1.964 0 01-.281-.48l-2.719-7.04a2.001 2.001 0 013.73-1.448l.81 2.078c1.46-5.328 1.28-10.09-.54-14.258C77.3 25.67 68 22.398 67.87 22.37a2.004 2.004 0 01-1.258-2.535 2.004 2.004 0 012.536-1.257c.449.148 11.07 3.82 15.5 13.84 2.37 5.351 2.488 11.43.39 18.102l3-1.172v.004a1.999 1.999 0 111.45 3.726h-.02z","fill":"currentColor"}})])
          )
        }
      }
    